import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProviderDetail, ProviderResult } from "../../../types/providerTypes";
import { EMPTY_PAGE_INFO, mergePage, Page, PageInfo, pageInfoOf } from "../../../utils/pagination";

// The last search, so "Load more" can fetch its next page
export type ProviderQuery =
  | { kind: "location"; stateId: number; lgaId: number | null; serviceId: number }
  | { kind: "nearby"; lat: number; lon: number; skillName: string };

interface ProviderState {
  results: ProviderResult[];
  resultsPageInfo: PageInfo;
  lastQuery: ProviderQuery | null;
  selectedProvider: ProviderDetail | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProviderState = {
  results: [],
  resultsPageInfo: EMPTY_PAGE_INFO,
  lastQuery: null,
  selectedProvider: null,
  loading: false,
  error: null,
};

const providerSlice = createSlice({
  name: "provider",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setResultsPage(
      state,
      action: PayloadAction<{ query: ProviderQuery; page: Page<ProviderResult> }>
    ) {
      state.results = mergePage(state.results, action.payload.page);
      state.resultsPageInfo = pageInfoOf(action.payload.page);
      state.lastQuery = action.payload.query;
      state.loading = false;
    },
    setSelectedProvider(state, action: PayloadAction<ProviderDetail | null>) {
      state.selectedProvider = action.payload;
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const providerActions = providerSlice.actions;

export default providerSlice;
